import { adminHeaders } from "./auth";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export async function fetchMarketplaceUsers() {
  const response = await fetch(`${API_URL}/marketplace-auth/users`, { headers: adminHeaders() });
  const data = await response.json().catch(() => []);
  if (!response.ok) throw new Error(data.message || "Unable to load marketplace users.");
  return data;
}
